import { useMutation } from "@tanstack/react-query";
import { profile } from "@shared/api/services";

export const useRequestSignCode = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: () => profile.signDocsRequest(),
	});
};
